import React from 'react';
import { faCheckCircle, faScrewdriver } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, Input } from 'reactstrap';
import { toast } from 'react-toastify';
import { BaseFormViewModel } from '../common/ViewModel';
import {
    FormLabel, onFieldChange, onReactSelectChanged, ToastMessage, ValidationErrorMessage, FormCheckbox
} from '../common/forms/FormElements';
import { CostCode } from './CostCode';
import CommonContext, { ApiRoutes } from '../Common';
import SlideForm from '../common/forms/SlideForm';
import { util } from '../Util';
import { handleFormSaveError } from '../common/forms/ValidationError';

export class CostCodeForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();

        const stateBase = {
            costCode: this.props.costCode ?? new CostCode(),
            show: false,
            ...new BaseFormViewModel(),
        };

        this.state = stateBase;
        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount() {
        this.populateState();
    }

    onChange = onFieldChange.bind(this);

    onClose(response) {
        this.setState({ show: false });
        this.resetForm();
        this.context.setFormOpened(false);
        this.props.onClose(response);
    }

    onSelectChange = onReactSelectChanged.bind(this);

    onSubmit = async (e) => {
        const { costCode } = this.state;

        // Clear any fluent api errors
        this.setState({ errors: {}, saving: true });

        // Is this POST or PUT?
        const url = costCode.id
            ? ApiRoutes.costCode.update(costCode.id)
            : ApiRoutes.costCode.create();
        const fetch_cte = costCode.id ? util.fetch.put : util.fetch.post;

        const response = await fetch_cte(url, costCode).catch(this.handleSaveError);

        if (response) {
            toast.success(<ToastMessage
                icon={faCheckCircle}
                header="Save Successful"
                message={`Cost Code [${costCode.description}] saved.`}
            />);
            this.setState({ show: false, saving: false });
            this.context.setFormOpened(false);
            this.resetForm();
            this.context.setFormOpened(false);
            this.props.onSaveCallback(response);
        }
    };

    handleSaveError = handleFormSaveError.bind(this);

    open = async (id) => {
        this.resetForm();
        this.setState({ show: true, loading: true });
        this.context.setFormOpened(true);

        let [costCode] = await Promise.all([
            (id ? util.fetch.js(ApiRoutes.costCode.byId(id)) : new CostCode())
        ]);

        this.setState({
            costCode,
            loading: false,
        });
    };

    async populateState() {
        this.setState((state) => ({
            loading: false
        }));
    }

    resetForm() {
        this.setState({ formValidated: false });
    }

    render() {
        const {
            formValidated, validationMessage,
        } = this.state;
        const costCode = this.state.costCode;
        return (
            <SlideForm
                loading={this.state.loading}
                show={this.state.show}
                id="costCodeForm"
                formIcon={faScrewdriver}
                formTitle={!!parseInt(costCode.id ?? 0) > 0 ? 'Edit Cost Code' : 'Add Cost Code'}
                ref={this.formRef}
                setIsValidated={(value) => { this.setState({ formValidated: value }); }}
                isValidated={formValidated}
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                onSave={this.onSave}
                onDelete={this.onDelete}
                errors={this.state.errors}
                onClearErrors={this.onClearErrors}
                validationMessage={validationMessage}
            >

                <FormGroup>
                    <FormLabel
                        htmlFor="costCodeNumber"
                        text="Cost Code Number"
                        required
                    />
                    <Input
                        id="costCodeNumber"
                        name="costCode.costCodeNumber"
                        value={costCode.costCodeNumber ?? ''}
                        onChange={this.onChange}
                        type="text"
                        required
                    />
                    <ValidationErrorMessage>Cost code number is required.</ValidationErrorMessage>
                </FormGroup>

                <FormGroup>
                    <FormLabel
                        htmlFor="description"
                        text="Description"
                        required
                    />
                    <Input
                        id="description"
                        name="costCode.description"
                        value={costCode.description ?? ''}
                        onChange={this.onChange}
                        type="text"
                        required
                    />
                    <ValidationErrorMessage>Description is required.</ValidationErrorMessage>
                </FormGroup>

                <FormGroup>
                    <FormCheckbox
                        id="isPrevailingWage"
                        name="codeCode.isPrevailingWage"
                        checked={
                            costCode.isPrevailingWage ?? false
                        }
                        onChange={(e) => {
                            let { costCode } = this.state;
                            costCode.isPrevailingWage = e.target.checked;
                            this.setState({ costCode: costCode }); 
                        }}
                        labelText="Uses Prevailing Wage"
                    />
                </FormGroup>
            </SlideForm>
        );
    }
}
